import { IconButton } from "@mui/material";
import { SnackbarProvider, useSnackbar } from "notistack";
import { Provider } from "react-redux";
import "./App.css";
import Iconify from "./components/iconify/Iconify";
import ProgressWrapper from "./components/progress-bar/ProgressWrapper";
import ThemeProvider from "./pages/theme";
import Store from "./reduxStore/Store";
import Routers from "./routers/Routers";

function App() {
  const SnackbarCloseButton = ({ snackbarKey }) => {
    const { closeSnackbar } = useSnackbar();

    return (
      <IconButton onClick={() => closeSnackbar(snackbarKey)}>
        <Iconify icon="ion:close-sharp" color="#fff" />
      </IconButton>
    );
  };

  return (
    <Provider store={Store}>
      <ThemeProvider>
        <SnackbarProvider
          maxSnack={1}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          action={(snackbarKey) => (
            <SnackbarCloseButton snackbarKey={snackbarKey} />
          )}
        >
          <div className="App">
            <ProgressWrapper />
            <Routers />
          </div>
        </SnackbarProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
